export default __webpack_public_path__ + "static/Fellix-SemiBold-6c283d4acd9fb5b5752904b0d614e739.otf";